import { useEffect } from "react";
import { LeafletPixiContext, PixiState, UseStateType } from "@pages/monitoring/map/hooks/useLeafletPixi";
import { ModeEnum } from "@modules/map/MapContainer";

export default function (pixiContext: LeafletPixiContext | undefined, [state, setPixiState] : UseStateType<PixiState>){
    useEffect(() => {
        if (pixiContext) {
            const contextMenuSelected = state.contextMenuSelected;
            if (contextMenuSelected && Object.entries(contextMenuSelected).length) {
                // @ts-ignore
                let contextmenu = pixiContext.map.contextmenu;
                contextmenu.removeAllItems();
                [
                    [{
                        text: `Показать детали`,
                        callback: () => {
                            setPixiState((state) => ({...state,
                                showOnMap: true,
                                selected: { list: [contextMenuSelected.glid], type: contextMenuSelected.area ? "FIELDS" : "UNITS" }}))
                        }
                    }],
                    contextMenuSelected.area ? [
                        {
                            text: `Редактировать геозону: ${contextMenuSelected.name} (${contextMenuSelected.glid})"`,
                            callback: () => {
                                setPixiState((state) => ({...state,
                                    showOnMap: true,
                                    mapMode: ModeEnum.POLYGON_EDITOR,
                                    selected: { list: [contextMenuSelected.glid], type: "FIELDS"}}))
                            }
                        }
                    ] : [],
                ].flat().forEach((item: any) => {
                    item && contextmenu.addItem(item)
                })
            }
        }
    }, [state.contextMenuSelected, pixiContext])
}